import { palette } from "../../styles";

export type TypographyVariants = keyof typeof typographyVariants;
export type TypographyTypes = keyof typeof typographyTypes;
export type FontFamilyType = keyof typeof fonts;
export type TypographyDecorations = keyof typeof typographyDecorations;

export const fonts = {
  bold: { fontFamily: "AzbukaPro-Bold" },
  regular: { fontFamily: "SharpGroteskBook20" },
  medium: { fontFamily: "SharpGroteskMedium20" },
};

export const typographyTypes = {
  disabled: { color: palette.common.disabled },
  success: { color: palette.common.green },
  error: { color: palette.font.error },
  lightError: { color: palette.primary.pinkSalmon },
  wrong: { color: palette.secondary.wrongPink },
  accent: { color: palette.primary.accent },
  accentDark: { color: palette.primary.accentDark },
  primary: { color: palette.font.primary },
  secondary: { color: palette.font.secondary },
  placeholder: { color: palette.font.placeholder },
  white: { color: palette.common.white },
  primaryLink: {
    color: palette.primary.main,
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
  },
  secondaryLink: { color: palette.font.secondary, textDecorationLine: "underline" },
  accentLink: { color: palette.primary.accent },
  workerError: { color: palette.worker.error },
};

export const typographyVariants = {
  bodyLight: { ...fonts.regular, fontSize: 14, lineHeight: 18 },
  body: { ...fonts.regular, fontSize: 16, lineHeight: 24 },
  bodyBold: { ...fonts.medium, fontSize: 16, lineHeight: 24 },
  button: { ...fonts.bold, fontSize: 16, lineHeight: 24 },
  input: { ...fonts.regular, fontSize: 16, lineHeight: 18 },
  label: { ...fonts.medium, fontSize: 13, lineHeight: 19 },
  largeLabel: { ...fonts.bold, fontSize: 18, lineHeight: 24 },
  smallLabel: { ...fonts.regular, fontSize: 13, lineHeight: 16 },
  largeParagraph: { ...fonts.regular, fontSize: 18, lineHeight: 27 },
  largeParagraphBold: { ...fonts.medium, fontSize: 18, lineHeight: 27 },
  largeTitle: { ...fonts.bold, fontSize: 28, lineHeight: 35 },
  lightLabel: { ...fonts.regular, fontSize: 13, lineHeight: 20 },
  lightLabelBold: { ...fonts.bold, fontSize: 13, lineHeight: 20 },
  paragraph: { ...fonts.regular, fontSize: 15, lineHeight: 22.5 },
  smallParagraph: { ...fonts.regular, fontSize: 10, lineHeight: 14 },
  paragraphBold: { ...fonts.medium, fontSize: 15, lineHeight: 25 },
  sectionTitle: { ...fonts.bold, fontSize: 20, lineHeight: 28.5 },
  title: { ...fonts.bold, fontSize: 23, lineHeight: 30 },
  webButton: { ...fonts.bold, fontSize: 17, lineHeight: 24 },
  webH2: { ...fonts.bold, fontSize: 20, lineHeight: 20 },
  webParagraph: { ...fonts.regular, fontSize: 18, lineHeight: 16 },
  newH1: { ...fonts.bold, fontSize: 28, lineHeight: 33.6 },
  newH2: { ...fonts.bold, fontSize: 25, lineHeight: 28 },
  newH3: { ...fonts.bold, fontSize: 20, lineHeight: 22 },
  newH4: { ...fonts.bold, fontSize: 16, lineHeight: 18 },
  newBodyBold: { ...fonts.medium, fontSize: 15, lineHeight: 22.5 },
  navItem: { ...fonts.medium, fontSize: 11, lineHeight: 16.5 },
  navItemLight: { ...fonts.regular, fontSize: 11, lineHeight: 16.5 },
  answerTitle: { ...fonts.bold, fontSize: 18, lineHeight: 20 },
  badge: { ...fonts.medium, fontSize: 12, lineHeight: 12 },
  navLink: { ...fonts.medium, fontSize: 20, lineHeight: 22 },
  navLinkLight: { ...fonts.regular, fontSize: 20, lineHeight: 22 },
  headerBold: { ...fonts.bold, fontSize: 48, lineHeight: 83 },

  buttonLink: {
    ...fonts.medium,
    fontSize: 16,
    lineHeight: 24,
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
  },
  link: {
    ...fonts.regular,
    fontSize: 15,
    lineHeight: 19,
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
  },
  smallLink: {
    ...fonts.regular,
    fontSize: 13,
    lineHeight: 16,
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
  },
};

export const typographyDecorations = {
  underline: {
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
  },
  lineThrough: {
    textDecorationLine: "line-through",
    textDecorationStyle: "solid",
  },
  lineThroughCapitalize: {
    textDecorationLine: "line-through",
    textDecorationStyle: "solid",
    textTransform: "capitalize",
  },
  upperCase: {
    textTransform: "uppercase",
  },
  capitalize: {
    textTransform: "capitalize",
  },
  none: {},
};
